import { render } from "./WebCamers.vue?vue&type=template&id=71d57453&scoped=true"
import script from "./WebCamers.vue?vue&type=script&lang=js"
export * from "./WebCamers.vue?vue&type=script&lang=js"

import "./WebCamers.vue?vue&type=style&index=0&id=71d57453&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d57453"]])

export default __exports__